import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import * as React from 'react';
import { UserGroupsComponent, UserGroupsComponentProps } from './userGroups';
import { UserLogsComponent, UserLogsComponentProps } from './userLogs';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

function tabProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const UserAddInfoTabsComponent = (props: {
  // groups
  groupsProps: UserGroupsComponentProps,
  // logs
  logsProps?: UserLogsComponentProps,
  // default
  style?: React.CSSProperties | undefined
}) => {
  const [currTab, setCurrTab] = React.useState(0);

  const onTabChange = (event: React.SyntheticEvent, newTabIndex: number) => {
    setCurrTab(newTabIndex);
  };

  return <>
    <Box sx={{ width: '100%', mt: 2 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={currTab} onChange={onTabChange} indicatorColor="primary" textColor="primary" variant="fullWidth">
          <Tab label="Grupos" {...tabProps(0)} />
          {props.logsProps?.userId ? <Tab label="Logs" {...tabProps(1)} /> : <></>}
        </Tabs>
      </Box>

      <TabPanel value={currTab} index={0}>
        <UserGroupsComponent
          {...props.groupsProps}

          style={{
            width: '100%',
            ...props.groupsProps.style,
          }}
        />
      </TabPanel>

      {props.logsProps?.userId ? <TabPanel value={currTab} index={1}>
        <UserLogsComponent
          {...props.logsProps}

          style={{
            width: '100%',
            ...props.logsProps.style
          }}
        />
      </TabPanel> : <></>}
    </Box>
  </>
}